import { mapState, mapActions, mapGetters } from 'vuex';

import { useDataLoading, usePagination } from '@mixins/factories';

const dataLoadingOptions = {
  getterName: 'getMachineDrawersHistory',
  contentName: 'machineDrawersHistory',
  parameterize: true,
  searchable: false,
};
const paginationOptions = { contentName: 'machineDrawersHistory' };

const machineDrawersHistoryHeaders = Object.freeze([
  { text: 'Operator', value: 'operator' },
  { text: 'Processed Date', value: 'processed' },
  { text: 'Capacity', value: 'capacity' },
  { text: 'Substrate', value: 'preferredSubstrate' },
  { text: 'Substrate Height', value: 'preferredSubstrateHeight' },
  { text: 'Substrate Width', value: 'preferredSubstrateWidth' },
  { text: 'State', value: 'state' },
]);

export default {
  name: 'MachineDrawersHistory',
  mixins: [
    useDataLoading(dataLoadingOptions),
    usePagination(paginationOptions),
  ],
  data() {
    return {
      machineDrawersHistoryHeaders,
    };
  },
  computed: {
    ...mapState('machines', ['machineDrawersHistory']),
    ...mapGetters('enums', ['machineDrawerStateEnumByKey']),
  },
  watch: {
    suffix(newValue) {
      this.$router.push({ name: 'machines', query: { suffix: newValue } });
    },
  },
  methods: {
    ...mapActions('machines', ['getMachineDrawersHistory']),
  },
};
